/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Meeting_Prep_Actions_Done_OpenInputs */



/**
* | output |
* | --- |
* | "Completed ({count})" |
*
* @param {Meeting_Prep_Actions_Done_OpenInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_actions_done_open = /** @type {((inputs: Meeting_Prep_Actions_Done_OpenInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Actions_Done_OpenInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Afgerond (${i?.count})`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Terminés (${i?.count})`)
	return /** @type {LocalizedString} */ (`Completed (${i?.count})`)
});